// Allow injecting a Sentry instance for Node.js environments
let sentryInstance = null;
export var Sentry;
(function (Sentry_1) {
    /** Set the Sentry instance (for Node.js apps using @sentry/node) */
    function setInstance(sentry) {
        sentryInstance = sentry;
    }
    Sentry_1.setInstance = setInstance;
    function getSentry() {
        if (sentryInstance)
            return sentryInstance;
        if (typeof window !== "undefined")
            return window.Sentry;
        return null;
    }
    function captureException(error, options = {}) {
        const Sentry = getSentry();
        if (Sentry) {
            Sentry.captureException(error, {
                tags: {
                    ...options.tags,
                    "client.version": "new_restaumatic_client",
                },
                level: options.level,
                extra: options.extra,
            });
        }
    }
    Sentry_1.captureException = captureException;
    function logError(error, options = {}) {
        captureException(error, { ...options, level: "log" });
    }
    Sentry_1.logError = logError;
})(Sentry || (Sentry = {}));
